<template>
  <div v-if="userCountry !== ''">
    <div v-if="methods[userCountry]">
      <div v-if="Object.keys(methods[userCountry]).length > 0">
        <div class="control">
          <div>
            <label for="methods">{{ $t('bank_name').tTitle() }}</label>
          </div>
          <span class="select">
            <select v-validate="'required'" :class="{ input: true, 'is-danger': errors.has('methods') }" name="methods" id="methods" v-model="payData.paymentMethodId">
              <option selected value>{{ this.$t('select').tTitle().tCapitalizeFirstLetter() }}</option>
              <option v-for="(method, id) in methods[userCountry]" :value="id" :key="id">{{ method.name }}</option>
            </select>
          </span>
          <span v-show="errors.has('country')" :class="{ 'has-text-right': Language == 'fa' || Language == 'ar' }" class="help is-danger">{{ errors.first('country') }}</span>
        </div>
        <br />
        <div v-if="['BR', 'EC', 'AR', 'CR', 'MX', 'CL', 'PE', 'CO', 'PA', 'GT'].includes(userCountry)">
          <div>
            <label for="personalId">{{ this.personalIdTitle }}</label>
          </div>
          <p class="control">
            <input
              v-validate="{ required: true, 'valid-cpf': this.userCountry }"
              :class="{ input: true, 'is-danger': errors.has('personalId') }"
              name="personalId"
              type="text"
              :data-vv-as="this.personalIdTitle"
              :placeholder="this.personalIdTitle"
              v-model="payData.personalId"
            />
            <span v-show="errors.has('personalId')" class="help is-danger" :class="{ 'has-text-right': Language == 'fa' || Language == 'ar' }">{{
              errors.first('personalId')
            }}</span>
          </p>
        </div>
        <br />
        <img
          v-if="false && payData.paymentMethodId != ''"
          :src="'https://payretailersstorage.blob.core.windows.net/payretailers-mgr-dev/' + methods[userCountry][payData.paymentMethodId].img"
          style="width: 180px; max-width: 180px"
        />
      </div>
      <br />
      <a @click="sendRequest" class="button is-success" v-if="payData.paymentMethodId != ''">
        {{ $t('deposit').tUpper() }}
      </a>
    </div>
    <div v-else>No options available for your country.</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      payData: {
        paymentMethodId: '',
        personalId: '',
      },
      userCountry: '',
      personalIdTitle: '',
      methods: {
        AR: {
          '270db565-1b32-468c-96e7-b2a9b19fdd1e': { name: 'Khipu', img: '9ef393b4-540b-4f11-957b-bb4410679ec9.PNG' },
        },
        BR: {
          '4819e438-3a72-4d27-9b2a-4ea5c9670fbc': { name: 'PIX', img: 'e279ecc9-662c-4ee4-95eb-a088ed823e0b.png' },
          '5c3e74c2-5f61-4033-afc5-7152b3c6b245': { name: 'Transferencia Bancaria', img: '5f19b06b-577c-4419-aeb2-f0d7c957674d.png' },
        },
        CL: {
          '7e31ce6a-9b99-4fd9-aa48-6d3691a93401': { name: 'Banco BCI', img: 'b6a19104-6ee4-46a3-8b36-2f21bce5fd45.jpe' },
          '6996ebe6-55d0-4dc7-8715-63876f167dfd': { name: 'Mach', img: '01ab8782-6fbf-411b-8ef5-158039f03a60.png' },
          '9fb3168a-57e6-4f44-b7e7-f40adc7c6a0b': { name: 'Khipu', img: 'dc39c59e-be87-4d18-ac60-9aae78ff1cf3.png' },
          '0f872bbd-e96c-4d9e-8da0-3a724869688d': { name: 'WebPay', img: 'e2b47fcc-6f70-4a51-a0a7-d98ed56a1d22.png' },
          '76c1ad55-8813-42a0-97eb-ea0d5ea076d8': { name: 'Multicaja', img: '36582e4f-8680-4eb8-8321-b88e64a3bf90.jpe' },
        },
        CO: { '4b67e5ee-1382-4388-872d-7e0a11c8af47': { name: 'PSE', img: '28a4b8b3-5910-4c9c-8ff8-ad91c17c6213.png' } },
        CR: { '512f98c7-f9ce-4204-b604-6227f3207e99': { name: 'Banco Nacional', img: '7fbe712a-7ca8-4ef9-aa37-d7002f3661e6.jpe' } },
        EC: {
          'ac8e4a09-9258-466d-9126-f8f891e0468f': { name: 'Banco Guayaquil', img: '389cff45-52cc-4303-af02-0abafd8445d2.png' },
          '643395e8-3eb7-4a5c-99ef-cf5a023e17be': { name: 'Banco Pichincha', img: '11c13a6a-4b6e-4a5e-a5f2-b931884fd56a.jpe' },
        },
        GT: {},
        MX: {
          'bd490cb0-695a-4c42-ade5-417e995b717d': { name: 'SPEI', img: '91ac5835-083c-4270-8183-692220c20656.jpe' },
          '0dfcb3f7-a033-4b46-a74b-f17b5eac81ef': { name: 'Scotiabank', img: '1f1eec49-72ee-4e50-a337-684dc2f240e8.jpe' },
        },
        PE: {
          'b1eba252-93f1-4209-a473-e1f16563c44c': { name: 'Banco de Crédito', img: '416c63dc-d969-4d2d-8a3a-1a602c7f2430.png' },
          '88764a73-3ad1-496c-9751-c4106958f914': { name: 'BBVA Continental', img: 'd87e66fd-b7db-42d9-8cc9-ccdaf3a4c407.png' },
          'b3085334-c865-4e70-81bc-05a6445e16d2': { name: 'Caja Arequipa', img: 'de985be0-bd67-4515-bf2a-9d38d7366346.png' },
          '3744fb0e-de3d-45e1-8651-621f9a589834': { name: 'Caja Huancayo', img: '3e2425a0-146b-424b-83aa-ba22250f1c26.png' },
          '067ba87a-ab20-413a-b163-afe5e99aae20': { name: 'Caja Tacna', img: '11b5c055-1219-482e-b7b5-7e740a618f14.jpe' },
          '5fb848bd-00f0-4c39-947c-f3552db503c7': { name: 'Caja Trujillo', img: '8b01c0d1-af2d-4a1d-9b5c-c7eb9f14fb94.jpe' },
          'f6c325ee-82d6-44ed-8621-4c2ebfb39309': { name: 'Interbank', img: 'b8b8826c-16dc-4a3d-9bc1-8b2d9a735502.jpe' },
          '6fa5018b-9377-4919-92f9-4d75a7bd62af': { name: 'Scotiabank', img: 'fe37b59e-e577-4042-843b-32a588392afb.jpe' },
        },
        SV: {},
      },
      translations: {
        text: {
          amount: this.$t('amount').tTitle(),
          currency: this.$t('currency'),
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
    }),
  },
  mounted() {
    this.userCountry = this.User.info.country_code
    switch (this.userCountry) {
      case 'BR':
        this.personalIdTitle = this.$t('personalId').tTitle()
        break
      case 'EC':
        this.personalIdTitle = this.$t('identity_card').tTitle()
        break
      case 'AR':
        this.personalIdTitle = this.$t('DNI_personalID').tTitle()
        break
      case 'MX':
        this.personalIdTitle = this.$t('CURP_personalID').tTitle()
        break
      default:
        this.personalIdTitle = this.$t('identity_card').tTitle()
        break
    }
  },
  methods: {
    sendRequest() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return false
        } else {
          if (this.payData.paymentMethodId != '') {
            this.$emit('request', this.payData)
          } else {
            this.$toasted.error('Select a payment method')
          }
        }
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// mulix-payretailers.vue?9356c58c